<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link
          v-for="(item, index) in navItems"
          :key="index"
          :to="item.route"
          :name="item.name"
          :icon="item.icon"
        />
      </template>
    </side-bar>
    <div
      class="main-panel"
      :style="{ 'border-top': '2px solid' + backgroundColor }"
    >
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import { mapGetters } from "vuex";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  data: () => ({
    isSuperAdmin: false,
    navItems: [
      { route: '/dashboard', name: 'Dashboard', icon: 'tim-icons icon-bank' },
      { route: '/found-games', name: 'Found Games', icon: 'tim-icons icon-alert-circle-exc' },
      { route: '/system-runs', name: 'System Runs', icon: 'tim-icons icon-chart-bar-32' },
      { route: '/football', name: 'Football', icon: 'tim-icons icon-world' },
      { route: '/basketball', name: 'Basketball', icon: 'tim-icons icon-spaceship' },
      { route: '/volleyball', name: 'Volleyball', icon: 'tim-icons icon-planet' },
      { route: '/handball', name: 'Handball', icon: 'tim-icons icon-tap-02' },
      { route: '/ice-hockey', name: 'Ice hockey', icon: 'tim-icons icon-molecule-40' },
      { route: '/rugby', name: 'Rugby', icon: 'tim-icons icon-palette' },
      { route: '/baseball', name: 'Baseball', icon: 'tim-icons icon-tablet-2' },
      { route: '/american-football', name: 'American football', icon: 'tim-icons icon-planet' },
      { route: '/floorball', name: 'Floorball', icon: 'tim-icons icon-molecule-40' },
      { route: '/futsal', name: 'Futsal', icon: 'tim-icons icon-palette' },
      { route: '/bandy', name: 'Bandy', icon: 'tim-icons icon-tap-02' },
      { route: '/water-polo', name: 'Water polo', icon: 'tim-icons icon-sound-wave' },
    ]
  }),
  computed: {
    ...mapGetters(["selectedBookie"]),
    backgroundColor() {
      switch (this.selectedBookie) {
        case "Odibets":
          return "#41b782";
        case "Betika":
          return "#247bf6";
        case "Flashscore":
          return "#d94fd2";
        case "Ababet":
          return "#053a85";
        default:
          return "#41b782";
      }
    },
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  mounted() {
    var userType = localStorage.getItem("type");
    userType == 2 ? (this.isSuperAdmin = true) : (this.isSuperAdmin = false);
  }
};
</script>
